import moment from 'moment';

import type IFilter from './interfaces';

export enum ECustomerSearchTypes {
  NAME = 'customer_name',
  EMAIL = 'customer_email',
  DOCUMENT = 'document_number',
}

export const CustomerTypes = [
  { label: 'CPF/CNPJ', value: ECustomerSearchTypes.DOCUMENT },
  { label: 'Email', value: ECustomerSearchTypes.EMAIL },
  { label: 'Nome', value: ECustomerSearchTypes.NAME },
];

export const InvoiceStatus = [
  { id: 1, label: 'Aberta', value: 'open' },
  { id: 15, label: 'Aguardando pagamento', value: 'waiting_payment' },
  { id: 6, label: 'Aguardando reembolso', value: 'waiting_refund' },
  { id: 4, label: 'Cancelada', value: 'canceled' },
  { id: 9, label: 'Duplicada', value: 'duplicated' },
  { id: 11, label: 'Em recuperação', value: 'recovering' },
  { id: 10, label: 'Expirada', value: 'expired' },
  { id: 19, label: 'Negociada', value: 'negociated' },
  { id: 3, label: 'Paga', value: 'paid' },
  { id: 7, label: 'Reembolsado', value: 'refunded' },
  { id: 55, label: 'Reembolso parcial', value: 'partial_refund' },
];

export const PaymentTypes = [
  { id: 2, label: 'Boleto', value: 'boleto' },
  { id: 1, label: 'Cartão de crédito', value: 'credit' },
  { id: 3, label: 'Paypal', value: 'paypal' },
];

const initialValues: IFilter = {
  date: [moment().subtract(7, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
  customer_type: ECustomerSearchTypes.EMAIL,
  customer: '',
  invoice_id: null,
  payment_status: [],
  payment_method: [],
  status: [],
  product_id: [],
};
export default initialValues;
